var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUartModbusType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.14 313.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6fccdd;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #6fccdd;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 19px;\r\n      }\r\n\r\n      .cls-3, .cls-2 {\r\n        fill: #97d3bb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.69,42.48v54.1h-15.93v-54.1c2.32,1.4,5.04,2.21,7.96,2.21s5.65-.81,7.97-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.69,228.63v42.75c-2.32-1.4-5.05-2.21-7.97-2.21s-5.64.81-7.96,2.21v-42.75h15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.17,95.68l-10.59,10.59-22.53,22.52-5.18,5.18-11.26-11.26,38.29-38.29c1.36,5.54,5.72,9.9,11.27,11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.33,200.02l-8.22,8.22-25.86,25.86c-1.34-5.55-5.7-9.92-11.23-11.3l10.58-10.58,17.8-17.8,5.66-5.66,11.27,11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.45,237.75c0,.26.01.52.02.77l-11.75-11.75-18.48-18.48-6.12-6.12,11.26-11.27,33.25,33.25c-4.87,2.58-8.18,7.71-8.18,13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.36,123.39l-11.26,11.26-2.7-2.7-36.44-36.44c1.37.41,2.82.62,4.32.62,5.12,0,9.66-2.5,12.47-6.35l9.86,9.86,23.75,23.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.87,51.44c-16.17,0-29.28,13.11-29.28,29.28,0,5.19,1.35,10.06,3.73,14.28,2.63,4.72,6.54,8.63,11.26,11.27,4.22,2.37,9.1,3.72,14.29,3.72,16.17,0,29.27-13.11,29.27-29.27s-13.1-29.28-29.27-29.28ZM238.87,96.13c-1.28,0-2.52-.16-3.7-.45-5.55-1.36-9.91-5.72-11.27-11.26-.29-1.18-.45-2.42-.45-3.7,0-8.52,6.9-15.42,15.42-15.42s15.41,6.9,15.41,15.42-6.9,15.41-15.41,15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.28,51.44c-16.17,0-29.28,13.11-29.28,29.28s13.11,29.27,29.28,29.27c3.07,0,6.02-.47,8.8-1.36,5.34-1.67,10.01-4.83,13.53-8.99,4.34-5.1,6.95-11.71,6.95-18.92,0-16.17-13.11-29.28-29.28-29.28ZM29.28,96.13c-1.5,0-2.95-.21-4.32-.62-6.41-1.86-11.09-7.78-11.09-14.79,0-8.52,6.9-15.42,15.41-15.42s15.41,6.9,15.41,15.42c0,3.39-1.1,6.52-2.94,9.06-2.81,3.85-7.35,6.35-12.47,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.87,208.47c-6.46,0-12.43,2.09-17.27,5.65-4.37,3.18-7.82,7.56-9.88,12.65-1.37,3.39-2.13,7.09-2.13,10.98,0,16.17,13.11,29.28,29.28,29.28s29.27-13.11,29.27-29.28-13.1-29.28-29.27-29.28ZM238.87,253.16c-8.26,0-15-6.49-15.4-14.64-.01-.25-.02-.51-.02-.77,0-5.89,3.31-11.02,8.18-13.6,2.16-1.16,4.62-1.81,7.24-1.81,8.51,0,15.41,6.9,15.41,15.41s-6.9,15.41-15.41,15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.85,223.5c-2.62-4.72-6.53-8.64-11.25-11.28-4.23-2.39-9.12-3.75-14.32-3.75-16.17,0-29.28,13.11-29.28,29.28s13.11,29.28,29.28,29.28,29.28-13.11,29.28-29.28c0-5.18-1.34-10.04-3.71-14.25ZM29.28,253.16c-8.51,0-15.41-6.9-15.41-15.41s6.9-15.41,15.41-15.41c1.29,0,2.55.16,3.74.46,5.53,1.38,9.89,5.75,11.23,11.3.29,1.17.44,2.39.44,3.65,0,8.51-6.9,15.41-15.41,15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.72,0c-16.16,0-29.27,13.11-29.27,29.27,0,13.41,9.02,24.71,21.31,28.17,2.53.73,5.2,1.11,7.96,1.11s5.44-.38,7.97-1.11c12.3-3.46,21.31-14.76,21.31-28.17,0-16.16-13.11-29.27-29.28-29.27ZM139.69,42.48c-2.32,1.4-5.05,2.21-7.97,2.21s-5.64-.81-7.96-2.21c-4.47-2.7-7.45-7.61-7.45-13.21,0-8.51,6.9-15.41,15.41-15.41s15.42,6.9,15.42,15.41c0,5.6-2.98,10.51-7.45,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M202.05,203.21v-81.21s-70.33-40.6-70.33-40.6l-70.32,40.6v81.21s70.32,40.6,70.32,40.6l70.33-40.6ZM74.54,195.62v-66.03s57.18-33.01,57.18-33.01l57.18,33.01v66.03s-57.18,33.01-57.18,33.01l-57.18-33.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.69,256.42c-2.53-.73-5.21-1.11-7.97-1.11s-5.43.38-7.96,1.11c-12.29,3.45-21.31,14.76-21.31,28.16,0,16.17,13.11,29.28,29.27,29.28s29.28-13.11,29.28-29.28c0-13.4-9.01-24.7-21.31-28.16ZM131.72,300c-8.51,0-15.41-6.9-15.41-15.42,0-5.6,2.98-10.5,7.45-13.2,2.32-1.4,5.04-2.21,7.96-2.21s5.65.81,7.97,2.21c4.47,2.7,7.45,7.6,7.45,13.2,0,8.52-6.9,15.42-15.42,15.42Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 238.86,
    cy: 237.75,
    r: 12.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 238.87,
    cy: 80.71,
    r: 12.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.28,
    cy: 237.75,
    r: 12.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.28,
    cy: 80.72,
    r: 12.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 131.72,
    cy: 284.59,
    r: 12.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 131.72,
    cy: 29.28,
    r: 12.07
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUartModbusType);
export default __webpack_public_path__ + "static/media/uart-modbus-type.90d8209d51c72b3f9bcd25f00e773da8.svg";
export { ForwardRef as ReactComponent };